import { apiClient } from './authService';

// REST API over the Payment model (money-out: fournisseur / charge).
const paymentService = {
  // Returns a plain array (the API is paginated; unwrap `results`).
  getAll: async (params = {}) => {
    const res = await apiClient.get('payments/', { params });
    return Array.isArray(res.data) ? res.data : (res.data.results || []);
  },

  // payload: { payment_type: 'supplier'|'charge', supplier?, charge?, amount, note? }
  create: async (data) => {
    const res = await apiClient.post('payments/', data);
    return res.data;
  },

  remove: async (id) => {
    await apiClient.delete(`payments/${id}/`);
  },

  // Attach a photo of the paper invoice/receipt to a payment (upload or camera
  // capture). The apiClient defaults to JSON, so the multipart header must be
  // forced (same fix as clientRecordService.saveRecord).
  uploadImage: async (id, file) => {
    const formData = new FormData();
    formData.append('image', file);
    const res = await apiClient.post(`payments/${id}/image/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  // Remove the attached photo
  deleteImage: async (id) => {
    const res = await apiClient.delete(`payments/${id}/image/`);
    return res.data;
  },
};

export default paymentService;
